import { BaseRequestModel } from '../../../base/base.request.model';

export class GenerateDeviceActivationCodeRequestMessage {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  GenerateDeviceActivationCodeRequestMessage!: GenerateDeviceCodeRequestModel;
}

export class GenerateDeviceCodeRequestModel extends BaseRequestModel {
  locale!: string;
  userAgent!: string;
  deviceDetails: { [key: string]: string } = {};
}
